// DIV MANAGER:
module.exports = function (RENDER, config) {
  this.divs = [];
  var tmpObj;

  // UPDATE:
  this.update = function (delta) {
    // DIVS:
    for (var i = this.divs.length - 1; i >= 0; --i) {
      tmpObj = this.divs[i];
      if (tmpObj.delay > 0) {
        tmpObj.delay -= delta;
        if (tmpObj.delay <= 0) {
          tmpObj.style.display = "inline-block";
        }
      } else {
        if (tmpObj.scale > tmpObj.minScale) {
          tmpObj.scale -= tmpObj.scaleSpeed * delta;
          if (tmpObj.scale <= tmpObj.minScale) {
            tmpObj.scale = tmpObj.minScale;
          }
          tmpObj.style.fontSize = tmpObj.scale + "px";
        }
        if (tmpObj.scaleSpd) {
          tmpObj.startS += tmpObj.scaleSpd * delta;
          tmpObj.style.width = tmpObj.startS + "px";
          tmpObj.style.height = tmpObj.startS + "px";
        }
        tmpObj.life -= delta;
        if (tmpObj.life <= 0) {
          tmpObj.style.display = "none";
          var tmpCallback = tmpObj.callback;
          this.divs.splice(i, 1);
          if (tmpCallback) {
            tmpCallback();
          }
        }
        if (tmpObj.fade && tmpObj.life <= tmpObj.fade) {
          tmpObj.style.opacity = tmpObj.life / tmpObj.fade;
        }
        if (tmpObj.srcA && tmpObj.srcA.cnt && tmpObj.maxLife - tmpObj.life <= tmpObj.srcA.tim) {
          var cVal = Math.floor(tmpObj.srcA.cnt * ((tmpObj.maxLife - tmpObj.life) / tmpObj.srcA.tim));
          tmpObj.src = "./textures/" + (tmpObj.srcA.src + "_" + cVal) + ".png";
        }
      }
    }
  };

  // ANIMATE TEXT:
  this.animateText = function (div, text, scale, scaleS, life, fade, delay, callback) {
    if (this.divs.indexOf(div) < 0) {
      this.divs.push(div);
    }
    div.delay = delay;
    if (!delay) {
      div.style.display = "inline-block";
    }
    div.style.fontSize = scale + "px";
    div.scale = scale;
    div.minScale = scaleS ? scale * 0.4 : scale;
    div.innerHTML = text;
    div.scaleSpeed = scaleS;
    div.life = life;
    div.fade = fade;
    div.style.opacity = 1;
    div.callback = callback;
  };

  // ANIMATE DIV:
  this.animateDiv = function (div, life, fade, startS, scaleSpd, srcA) {
    if (this.divs.indexOf(div) < 0) {
      this.divs.push(div);
    }
    div.style.display = "block";
    div.life = life;
    div.maxLife = life;
    div.srcA = srcA;
    if (srcA) {
      div.src = "./textures/" + srcA.src + "_0.png";
    }
    div.style.opacity = 1;
    div.fade = fade;
    if (startS) {
      div.style.width = startS + "px";
      div.style.height = startS + "px";
      div.startS = startS;
      div.scaleSpd = scaleSpd;
    }
  };

  // RESET:
  this.reset = function () {
    for (var i = 0; i < this.divs.length; ++i) {
      this.divs[i].style.display = "none";
    }
    this.divs.length = 0;
  };
};